<template>
  <div id="myModal" class="modall" v-if="show_image">
    <span id="cclose" class="close" @click="show_image = false">&times;</span>
    <img class="modall-content" v-bind:src="'https://uti.umbgrup.ro/images/' + alimentare_imagine">
    <div id="caption"></div>
  </div>

  <div class="home">

    <button class="btn btn-sm btn-success" style="margin:10px; font-size: 1em; font-weight: bold;"
      @click="intreaba_logout">
      {{nume}} - {{marca}}</button>

    <div class="container-md">
      <div class="flex-box-2">
        <button class="btn btn-sm btn-secondary " @click="schimba_data(-1)">&lt;</button>
        <p style="margin:0.4em 0em 0.3em;" id="data_pontaj" onclick="data_change(0);">{{data_a}}</p>
        <button class="btn btn-sm btn-secondary " @click="schimba_data(1)">&gt;</button>
      </div>
      <div>
        <nav aria-label="lista_fcs">
          <ul class="pagination">
            <li class="page-item"><a class="page-link" @click="docnew">+</a></li>
            <li class="page-item" aria-current="page" :class="{active: lucrare_index==index}"
              v-for="(item, index) in lucrari" v-bind:key="index" @click="lucrare_index = index; edit_lucrare = false;">
              <span class="page-link">{{index}}</span>
            </li>
          </ul>
        </nav>
        <div class="card" v-if="lucrare_index > -1">
          <div class="card-header">
            <p style="display: inline;" v-if="!can_be_edited">{{santier}}</p>
            <div class="input-group mb-1" v-if="can_be_edited">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:125px;">Santier:</span>
            </div>
            <FSelectSantier v-bind:options="santiere" v-bind:initial="rap?.santier??-1" v-on:fselect="on_schimba_santier"/>
            </div>
          </div>
          <div class="card-body">
            <div class="input-group mb-1" v-if="de_salvat">
              <button class="btn btn-warning" style="width: 100%"
                @click="salveaza_lucrare"
              >Salvează!!!</button>
            </div>
            <div class="input-group mb-1">
              <span class="input-group-text" style="width: 100px;">km/locație</span>
              <input type="text" class="form-control" v-model="lucrari[lucrare_index].pozitia" required
                :disabled="!can_be_edited"
                @input="markAsModified" 
                @keyup="markAsModified">
            </div>
            <div class="input-group mb-1" v-if="edit_lucrare">
              <span class="input-group-text" style="width: 100px;">categorie</span>
              <FSelectObj v-bind:options="lcs_type" :initial="lcs_type_selected" v-on:fselectobj="categorieSelectata" v-if="edit_lucrare" />
            </div>
            <div class="input-group mb-1">
              <FSearchSelect :options="lcs_filtered" :utilaj="lucrare_name" v-on:lucrare_selectata="on_lucrare_selectata" v-if="edit_lucrare">
              </FSearchSelect>
              <button class="btn btn-sm btn-secondary" style="width: 100%;" @click="set_edit_lucrare" v-if="!edit_lucrare"
              :disabled="!can_be_edited">{{ lucrare_name.element }} {{ lucrare_name.categorie_denumire }} {{ lucrare_name.um_denumire }}</button>
            </div>
            <div class="input-group mb-1">
              <span class="input-group-text" style="width: 100px;">cantitate</span>
              <input type="number" class="form-control" v-model="lucrari[lucrare_index].cantitate" required
                :disabled="!can_be_edited"
                @input="markAsModified" 
                @keyup="markAsModified">
            </div>
            <div class="input-group mb1">
              <span class="input-group-text" style="width: 100%;">Detalii lucrare</span>
            </div>
            <div class="input-group mb-1">
              <textarea class="form-control" v-model="lucrari[lucrare_index].detaliu" placeholder="Detaliu lucrare"
                rows="4" :disabled="!can_be_edited"

                @input="markAsModified" 
                @keyup="markAsModified"></textarea>
            
            </div>

          </div>
          <div class="card-footer">
            <div class="input-group mb-1 d-flex">
              <span class="input-group-text flex-fill text-start">Câștig Echipă: {{ lucrari[lucrare_index].earning }} </span>
              <span class="input-group-text flex-fill text-end">Oameni: {{ lucrari[lucrare_index].lucratori }}</span>
            </div>  
          </div>
        </div>


      </div>
      <!-- Modal window select New Ordin de deplasare -->
      <div class="card" v-if="od_new_data">
        <div class="card-header">
          Selectie date ordin
        </div>
        <div class="card-body">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style=" padding-top: .5em; padding-bottom: .5em; width: 130px;">De la
              </span>
            </div>
            <input v-model="od_data_from" type="date" class="form-control">
          </div>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style=" padding-top: .5em; padding-bottom: .5em; width: 130px;">Pana la
              </span>
            </div>
            <input v-model="od_data_to" type="date" class="form-control">
          </div>
        </div>
        <div class="card-footer">
          <button class="btn btn-info float-left" style="width: 130px;" @click='init_od' :disabled='!initODEn'> Initiaza
            OD</button>&nbsp;
          <button class="btn btn-warning float-right" style="width:130px;" @click='close_doc'>Uita</button>
        </div>
      </div>

      <!-- Modal window select New fc/faz-->
      <div class="card" v-if="fc_new">
        <div class="card-header">
          <p style="display: inline;">Inceput {{fcn_data}}</p>
          &nbsp;
        </div>
        <div class="card-body">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:125px;">Santier:</span>
            </div>
            <FSelectSantier v-bind:options="santiere" v-model="sass" />
          </div>

          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:125px;">Utilaj tip:</span>
            </div>
            <FSelect v-bind:options="ut" :initial="'Favorite'" v-bind:valoare="uts" v-on:fselect="utilajSelectat" />
          </div>

          <div class="input-group mb-3">
            <FSearchSelect :options="uts" :utilaj="utilaj_s" v-on:utilaj_selectat="utilaj_selectat">
            </FSearchSelect>
          </div>

          <div class="input-group mb-3">
            <div class="input-group-prepend">
              <span class="input-group-text" style="width:125px;">Index initial:</span>
            </div>
            <input type="number" class="form-control" min="1" v-model="utilaj_i">
          </div>
          <div class="input-group mb-3" v-if="utilaj_poateremorca">
            <div class="input-group-prepend">
              <span class="input-group-text" style="padding-left:2px;width:25px;"><font-awesome-icon
                  icon="trailer" />:</span>
            </div>
            <FSelect style="background-color:lightgray;" ref="selectTipRemorca" v-bind:options="remorci_type"
              v-bind:valoare="remorci" v-on:fselect="remorcaSelectat" />
            <FSearchSelect style="width:60%; display: inline-flex;" :options="remorci" :utilaj="remorca_s"
              v-on:utilaj_selectat="remorca_selectat">
            </FSearchSelect>
          </div>

        </div>

        <div class="card-footer">
          <button class="btn btn-primary float-left" style="width:130px;" @click='init_fc'
            :disabled='!initFcEn'>Initiaza FC</button>&nbsp;
          <button class="btn btn-warning float-right" style="width:130px;" @click='close_doc'>Uita</button>
          <br>
          <button class="btn btn-success float-left" style="width: 130px; margin-top: 5px;" @click='init_faz'
            :disabled='!initFazEn'>Initiaza FAZ</button>&nbsp;
          <button class="btn btn-info float-right" style="width: 130px; margin-top: 5px;" @click='select_data_od'
            :disabled='!initODEn'> Initiaza OD</button>
        </div>

      </div>

      <!-- Modal when fc/od is sent for confirm -->
      <SelectInginer ref="seling" :ingineri="ingineri" :selecteaza_inginer="selecteaza_inginer"
        v-on:uita_inginer_selectat="uita_inginer_selectat" v-on:inginer_confirmare="inginer_confirmare"
        titlu="Inginer Confirmare">
      </SelectInginer>


      <!-- Modal window edit route of fcfaz -->
      <!-- <div class="card" style="width:100%" v-if="traseu_edit">
        <form @submit.prevent="traseu_save">
          <div class="card-body">
        
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:100px;">Plecare:</span>
              </div>
              <input type="text" class ="form-control" v-model="traseu_plecare" placeholder="locatie" required :disabled="fcs[fc_index].satre > 0">
            </div>
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:100px;">Sosire:</span>
              </div>
              <input type="text" class="form-control" v-model="traseu_sosire" placeholder="locatie" required :disabled="fcs[fc_index].satre > 0">
            </div>
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:100px;">Km plin:</span>
              </div>
              <input type="number" class="form-control" v-model="traseu_km_plin" min="0" max="2000" step=".1" required :disabled="fcs[fc_index].satre > 0">
              <div class="input-group-append">
                  <span class="input-group-text" style="width:80px;">{{ traseu_ckm_plin }}</span>
              </div>
            </div>
            <div class="input-group mb-3">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:100px;">Km gol:</span>
              </div>
              <input type="number" class="form-control" v-model="traseu_km_gol" min="0" max="2000" step=".1" required :disabled="fcs[fc_index].satre > 0">
              <div class="input-group-append">
                <span class="input-group-text" style="width:80px;">{{ traseu_ckm_gol }}</span>
              </div>
            </div>
            <div class="input-group mb-1">
              <div class="input-group-prepend">
                <span class="input-group-text" style="width:100px;">Incarcatura:</span>
              </div>
              <select v-model="traseu_tip_incarcatura" class="form-control" required :disabled="fcs[fc_index].satre > 0">
                <option v-for="(option, index) in tip_i" v-bind:key="index" v-bind:value="option">{{ option }}</option>
              </select>
            </div>
            <div class="input-group mb-1">
                <div class="input-group-prepend">
                  <span class="input-group-text" style="width:100px;">Cantitate:</span>
                </div>
                <input type="number" class="form-control" v-model="traseu_cantitate" min="0" max="80000" step="0.1" required :disabled="fcs[fc_index].satre > 0">
            </div>
            <div class="input-group mb-1">
                  <div class="input-group-prepend">
                    <span class="input-group-text" style="width:100px;">Nr. curse:</span>
                  </div>
                  <input type="number" class="form-control" v-model="traseu_nr_curse" min="1" max="1000" required :disabled="fcs[fc_index].satre > 0">
            </div>
            <div class="input-group mb-3">
                    <div class="input-group-prepend">
                      <span class="input-group-text" style="width:100px;">Basculari:</span>
                    </div>
                    <input type="number" class="form-control" v-model="traseu_basculari" min="0" :max="traseu_nr_curse*10" required :disabled="fcs[fc_index].satre > 0">
                    <div class="input-group-append">
                      <span class="input-group-text" style="width:80px;">{{ traseu_cbasculari }}</span>
                    </div>
              </div>
              <textarea class="form-control" v-model="traseu_detalii_transport" placeholder="Detalii transport" :disabled="fcs[fc_index].satre > 0"></textarea>
          </div>
          

          <div class="card-footer" style="padding-left: 2px; padding-right: 2px;">
            <button class="btn btn-primary" style="width:80px;padding: 5px;" type="submit" :disabled="fcs[fc_index].satre > 0">Salveaza</button>&nbsp;
            <button class="btn btn-warning" style="width:80px; padding: 5px;" type="button" @click='traseu_close'>Uita</button>&nbsp;
            <button class="btn btn-danger" style="width:80px; padding: 5px;" type="button" @click='traseu_sterge' :disabled="fcs[fc_index].satre > 0">Sterge</button>&nbsp;
          </div>
        </form>  
      </div>  -->

      <!-- Modal window edit lucrare -->
      <!-- 
      <div class="card" style="width:100%" v-if="lucrare_edit">
        <form @submit.prevent="lucrare_save">
          <div class="card-body" style="padding: 4px;">
            <div :class="fcs[fc_index].satre > 0 ?'text-muted':'text-white bg-success'" style="border: 1px solid; border-color: lightslategrey; border-radius: 7px; margin-bottom: 5px; font-weight: bold;">Schimburi / Reparații</div>
            <div class="row">
              <div class="col" style="padding-right: 0px; margin-right: 0px;">
                <div class="form-switch" style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="ulei_motor" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Ulei motor</label>
                </div>
              </div>
              <div class="col" style="padding-left: 0px; margin-left: 0px;">
                <div class="form-switch"  style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="filtru_ulei_motor" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Filtru ulei motor</label>
                </div>
              </div>
            </div>

            <div class="row">
                <div class="col" style="padding-right: 0px; margin-right: 0px;">
                </div>
                <div class="col" style="padding-left: 0px; margin-left: 0px;">
                  <div class="form-switch"  style="text-align: left;">
                    <input class="form-check-input" type="checkbox" v-model="filtru_combustibil" :disabled="fcs[fc_index].satre > 0">&nbsp;
                    <label class="form-check-label" >Filtru combustibil</label>
                  </div>
                </div>
            </div>
            <div class="row">
              <div class="col" style="padding-right: 0px; margin-right: 0px;">
              </div>
              <div class="col" style="padding-left: 0px; margin-left: 0px;">
                <div class="form-switch"  style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="filtru_aer" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Filtru aer</label>
                </div>
              </div>
            </div>
            <div class="row">
                <div class="col" style="padding-right: 0px; margin-right: 0px;">
                </div>
                <div class="col" style="padding-left: 0px; margin-left: 0px;">
                  <div class="form-switch"  style="text-align: left;">
                    <input class="form-check-input" type="checkbox" v-model="filtru_polen" :disabled="fcs[fc_index].satre > 0">&nbsp;
                    <label class="form-check-label" >Filtru polen</label>
                  </div>
                </div>
            </div>
            <div class="row">
                  <div class="col" style="padding-right: 0px; margin-right: 0px;">
                  </div>
                  <div class="col" style="padding-left: 0px; margin-left: 0px;">
                    <div class="form-switch"  style="text-align: left;">
                      <input class="form-check-input" type="checkbox" v-model="filtru_adblue" :disabled="fcs[fc_index].satre > 0">&nbsp;
                      <label class="form-check-label" >Filtru AdBlue</label>
                    </div>
                  </div>
              </div>
            <div class="row">
                  <div class="col" style="padding-right: 0px; margin-right: 0px;">
                  </div>
                  <div class="col" style="padding-left: 0px; margin-left: 0px;">
                    <div class="form-switch"  style="text-align: left;">
                      <input class="form-check-input" type="checkbox" v-model="filtru_uscator" :disabled="fcs[fc_index].satre > 0">&nbsp;
                      <label class="form-check-label" >Filtru uscator</label>
                    </div>
                  </div>
              </div>
            
            <div class="d-flex align-items-center">
              <span class="px-3">500 ore +</span>
              <span class="flex-grow-1" style="border-bottom: 1px solid;"></span>
            </div>
            
            <div class="row">
              <div class="col" style="padding-right: 0px; margin-right: 0px;">
                <div class="form-switch" style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="ulei_cutie" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Ulei cutie</label>
                </div>
              </div>
              <div class="col" style="padding-left: 0px; margin-left: 0px;">
                <div class="form-switch"  style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="filtru_ulei_cutie" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Filtru ulei cutie</label>
                </div>
              </div>
            </div> 
            <div class="row">
                <div class="col" style="padding-right: 0px; margin-right: 0px;">
                  <div class="form-switch" style="text-align: left;">
                    <input class="form-check-input" type="checkbox" v-model="ulei_punte" :disabled="fcs[fc_index].satre > 0">&nbsp;
                    <label class="form-check-label" >Ulei punte</label>
                  </div>
                </div>
                <div class="col" style="padding-left: 0px; margin-left: 0px;">
                </div>
              </div> 
            <div class="d-flex align-items-center">
              <span class="px-3">1000 ore +</span>
              <span class="flex-grow-1" style="border-bottom: 1px solid;"></span>
            </div>
            
            <div class="row">
              <div class="col" style="padding-right: 0px; margin-right: 0px;">
                <div class="form-switch" style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="ulei_hidraulic" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Ulei hidraulic</label>
                </div>
              </div>
              <div class="col" style="padding-left: 0px; margin-left: 0px;">
                <div class="form-switch"  style="text-align: left;">
                  <input class="form-check-input" type="checkbox" v-model="filtru_ulei_hidraulic" :disabled="fcs[fc_index].satre > 0">&nbsp;
                  <label class="form-check-label" >Filtru ulei hidraulic</label>
                </div>
              </div>
            </div> 
            
              <textarea class="form-control" v-model="lucrare_detalii" placeholder="Detalii lucrari efectuate" rows="4" :disabled="fcs[fc_index].satre > 0"></textarea>
          </div>
        

          <div class="card-footer" style="padding-left: 2px; padding-right: 2px;">
            <button class="btn btn-primary" style="width:80px;padding: 5px;" type="submit" :disabled="fcs[fc_index].satre > 0">Salveaza</button>&nbsp;
            <button class="btn btn-warning" style="width:80px; padding: 5px;" type="button" @click='lucrare_close'>Uita</button>&nbsp;
            <button class="btn btn-danger" style="width:80px; padding: 5px;" type="button" @click='lucrare_sterge' :disabled="fcs[fc_index].satre > 0">Sterge</button>&nbsp;
          </div>
        </form>  
      </div>
    -->
    </div>

    <!-- Modal confirm -->
    <confirmare ref="dialogDeConfirmare"></confirmare>
  </div>



  <input type="file" hidden accept="image/*; capture=camera " id="i_input" @change="ichange">


</template>

<script>
import axios from 'axios'
import strftime from '../helpers/strftime'
import FSelect from '../components/FSelect.vue'
import FSelectSantier from '../components/FSelectSantier.vue'
import FSearchSelect from '../components/FSearchSelect.vue'
import SelectInginer from '../components/SelectInginer.vue'
import resizeImage from '../helpers/resizeImage'

import Confirmare from '../components/Confirmare.vue'
import FSelectObj from '../components/FSelectObj.vue'

const axi = axios.create({baseURL: 'https://uti.umbgrup.ro',})
let isRefreshing = false;

function isTokenExpired(token) {
  try {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;
  } catch (e) { console.log(e); }
  return false;
}


export default {
  name: 'Home',
  components:{
    FSelect,
    FSelectObj,
    FSelectSantier,
    FSearchSelect,
    SelectInginer,
    Confirmare,
  },

  data(){
    return{
      nume:'',
      marca: '',
      raport: [],
      raport_edit: false,
      raport_selected: false,
      raport_new: false,
      raport_index: -1,
      lucrare_index: -1,
      lcs: [],
      lcs_filtered: [],
      lcs_type: {},
      edit_lucrare: false,
      de_salvat: false,

      fcs:[],
      ingineri: [],
      impegati: [],
      santiere:[],
      ut: [],
      remorci_type: ['Bena', 'Cisterna', 'Remorca', 'Trailer', 'Vagon'],
      remorci: [],
      autentificat: false,
      data: null,
      data_: '',
      data_a: '',
      fc_index: -1,
      fc_selected: false,
      fc_new: false,
      fcn_data : '',
      fcn_inv : '',
      fcn_index : '',
      uts: [],
      remorca: null,
      remorca_s: '',
      setare_remorca: false,
      utilaj_s: '----',
      utilaj_id: -1,
      utilaj_i: -1,
      utilaj_ii: -1,
      utilaj_new_rezervor_in: 0,
      utilaj_poateremorca: false,
      sass: 'Favorite',
      od_index: -1,
      od_selected: false,

      selecteaza_inginer: false,
      alim_edit: false,

      alim_id: null,
      alimentare_litri: '',
      alimentare_de_la: '',
      alimentare_este_document: 'nu',
      alimentare_imagine_noua: null,
      alimentare_imagine: null,
      alimentare_fc: 0,
      show_image: false,

      ods:[],

      initFcEn: false,
      initFazEn: false,
      initODEn: false,

      od_new_data: false,
      od_data_from: null,
      od_data_to: null,

      traseu_edit: false,
      traseu_plecare: '',
      traseu_sosire: '',
      traseu_km_plin: 0,
      traseu_km_gol: 0,
      traseu_ckm_plin: 0, 
      traseu_ckm_gol: 0,
      traseu_nr_curse: 1,
      traseu_cantitate: 0,
      traseu_tip_incarcatura: '',
      traseu_detalii_transport: '',
      traseu_id: null,
      traseu_basculari: 0,
      traseu_cbasculari: 0,
      tip_i: [],

      lucrare_edit: false,
      ulei_motor: false,
      filtru_ulei_motor: false,
      filtru_combustibil: false,
      filtru_aer: false,
      filtru_polen: false,
      filtru_adblue: false,
      filtru_uscator: false,
      ulei_cutie: false,
      filtru_ulei_cutie: false,
      ulei_punte: false,
      ulei_hidraulic: false,
      filtru_ulei_hidraulic: false,
      gresare: false,
      lucrare_detalii: "",
    }
  },

  computed: {
    total_alimentari: function() {
      return (this.fcs.length > 0 && this.fc_index > -1 ? this.fcs[this.fc_index].alimentari.reduce((acc, item) => acc + item.alimentare, 0).toFixed(2) : 0);
    },
    santier: function() {
      const st = this.raport_index > -1 ? this.santiere.findIndex(e => e[0] === this.raport[this.raport_index].santier) : -1;
      return st > -1 ? this.santiere[st][1] : 'Șantier';
    },
    rap: function() {
      return this.raport_index > -1 ? this.raport[this.raport_index] : null;
    },
    lucrari: function() {
      return this.raport_index > -1 && this.lucrare_index > -1 ? this.rap.lucrari : [];
    },
    lucrare_name: function () {
      if (this.lucrare_index < 0) return {element:'Lucrare', categorie:-1, categorie_denumire: 'Categorie', um_denumire: 'UM'};
      const l = this.lucrari[this.lucrare_index];
      const idx = this.lcs.findIndex(e => e.id === l.lucrare);
      return idx > -1 ? this.lcs[idx] : {element:'Lucrare', categorie:-1, categorie_denumire: 'Categorie', um_denumire: 'UM'};
    },
    lcs_type_selected: function () {
      if (this.lucrare_index < 0) return -1;
      const li = this.lcs.findIndex(e => e.id == this.lucrari[this.lucrare_index].lucrare);
      if (li < 0) return -1;
      return this.lcs[li].categorie;
    },
    lucrare_selectata: function () {
      return this.lucrare_index > -1 ? this.lucrari[this.lucrare_index].lucrare : -1;
    },
    can_be_saved: function () {
      return this.de_salvat && this.lucrare_index > -1 && this.lucrari[this.lucrare_index].lucrare > 0 && this.lucrari[this.lucrare_index].cantitate > 0;
    },
    can_be_edited: function () {
      return this.lucrare_index > -1 && this.rap != null && ( new Date() - new Date(this.rap.data)) <  2 * 3600 *24 *1000;
    },
  },

  created() {
    this.$store.dispatch('checkAuthenticated')

  },

  async mounted(){
    this.data = new Date();
    this.data_a = strftime("%a  %d.%m.%Y", this.data, "RO");
    this.autentificat = this.$store.state.authenticated;
    if(!this.autentificat){
      this.$router.push("/login");
    }else{
      axi.interceptors.request.use((config) => {
        const token = this.$store.state.authToken
        if ((token) && !isTokenExpired(token)) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
        (error) => Promise.reject(error)
      );

      axi.interceptors.response.use(
        (response) => {
          return Promise.resolve(response);
        },
        async (error) => {
          const originalRequest = error.config;
          //alert(error.response.status);
          if ((error.response.status === 401 )&& !originalRequest._retry) {
            if (isRefreshing) {
              return await new Promise(resolve => {
                setTimeout(() => resolve(axi(originalRequest)), 2000);
              });
            }
            isRefreshing = true;
            try {
              await this.$store.dispatch('rrefreshToken');
              isRefreshing = false;
              return await axi(originalRequest);
            } catch (err) {
              isRefreshing = false;
              await this.$store.dispatch('logout');
              this.$router.push("/login");
              return Promise.reject(err);
            }
          }
          return Promise.reject(error);
        }
      );
      
      this.ref();
    }
  },
  methods: {
    ref: function () {
      const panou = document.getElementById("loading");
      panou.style.display = 'flex';
      axi.get('rapoarte_getStatus/')
      .then(date => {
        if (date.data.ANS==='OK'){
          this.nume = date.data.Nume;
          this.marca = date.data.marca;
          this.raport = [...date.data.raport];
          this.santiere = [...date.data.santiere];
          this.santiere.push([-1, 'Șantier']);
          this.raport_selected = this.raport.length > 0;
          this.raport_new = false;
          this.raport_index = this.raport.length > 0 ? 0 : -1;
          this.lucrare_index = this.raport.length > 0 && this.raport[0].lucrari.length > 0 ? 0 : -1;
        }
        console.log(date.data);
        panou.style.display = "none";
      })
        .catch(e => {
          console.log(e);
          panou.style.display = "none";
        })
      axi.get('rapoarte_getLucrari/')
        .then(date => {
          this.lcs = [...date.data.lucrari];

          const lt = this.lcs.reduce((acc, item) => {
            acc[item.categorie] = item.categorie_denumire;
            return acc;
          }, {});
          this.lcs_type = Object.assign({ '-1': 'Toate' }, lt);
          this.lcs_filtered = [...this.lcs];
        })
        .catch(e => {
          console.log(e);
        })
    },
    intreaba_logout: function(){
      if(confirm("Doriți să schimbați utilizatorul?")){
        this.$router.push("/login");
      }
    },
    set_edit_lucrare: function(){
      this.edit_lucrare = !this.edit_lucrare;
    },
    markAsModified: function(){
      this.de_salvat = true;
    },
    schimba_data: async function(zile){
      this.raport_edit = false;
      let dataa = new Date((new Date(this.data.getTime() + zile * 3600 *24 *1000)).toISOString().substring(0,10))
      if(dataa <= new Date()){
        this.data = dataa
        this.data_ = dataa.toISOString().substring(0, 10);
        this.data_a = strftime("%a  %d.%m.%Y", this.data, "RO");
        const panou = document.getElementById("loading");
                panou.style.display = 'flex';
        try{
          const resp = await axi.get(`rapoarte_getStatus/?data=${this.data.toISOString().substring(0,10)}`)
          //alert(resp)
          if(resp.status != 200){
            alert(resp.status)
            this.$router.push("/login")
            return
          }
          const data = resp.data;
          if (data.ANS==='OK'){
              this.nume = data.Nume;
              this.marca = data.marca;
              this.raport = [...data.raport];

            this.raport_selected = this.raport.length > 0;
            this.raport_new = false;
            this.raport_index = this.raport.length > 0 ? 0 : -1;
            this.lucrare_index = this.raport.length > 0 && this.raport[0].lucrari.length > 0 ? 0 : -1;

            }

        }catch(e){
          alert(e);
        }
        panou.style.display = 'none'
      }
    },
    close_doc: function(){
      this.fc_new = false;
      this.od_new_data = false;
      this.setare_remorca = false;  
    },
    docnew: function(){
      // ar trebui sa verifici data si sa mai faci ajustari
      // exista raport ?
      if (this.raport.length === 0) {
        if(new Date() - this.data > 2 * 3600 * 24 * 1000){
          alert("Nu se poate crea un raport pentru o dată anterioară");
          return;
        }
        this.raport = [{data: this.data.toISOString().substring(0,10), lucrari: [], santier: -1}];
        this.raport_index = 0;
        this.raport_selected = true;
        this.raport_new = true;
        this.lucrare_index = -1;
        
      } else {
        if(new Date() - this.data > 2 * 3600 * 24 * 1000){
          alert("Nu se poate adăuga o lucrare la un raport pentru o dată anterioară");
          return;
        }
      }
      const lucrare_new = {
        cantitate: 0,
        pozitie: "km",
        detaliu: "",
        lucrare: -1,
      };
      this.raport[0].lucrari.push(lucrare_new);
      this.de_salvat = true;
      this.lucrare_index = this.raport[0].lucrari.length - 1;
    },
    poate_remorca: function(){
      return this.fc_index > -1 && (this.fcs[this.fc_index].utilaj__tip === 'Cap Tractor' || this.fcs[this.fc_index].utilaj__tip === 'Autovehicul');
    },
    salveaza_lucrare: async function () {
      const panou = document.getElementById("loading");
      panou.style.display = 'flex'; 
      try {
        const formData = { ...this.rap };
        const rest = this.rap?.id > 0 ? await
          axi.put(`rapoarte_setRaport/`, formData) :
          axi.post(`rapoarte_setRaport/`, formData);
        const data = rest.data; 
        if (rest.status === 200) {
          this.de_salvat = false;
          this.edit_lucrare = false;
        }
        else {
          alert(data.MSG);
        }
      }catch(e){
        console.log(e)
      }
      panou.style.display = 'none'
    },
    select_document: function(new_index){
      this.fc_index = new_index;
      this.od_index = -1;
      this.fc_selected = this.fc_index > -1;
      this.od_selected = this.od_index > -1;
    },
    select_documentOD: function (new_index) {
      this.od_index = new_index;
      this.fc_index = -1;
      this.fc_selected = this.fc_index > -1;
      this.od_selected = this.od_index > -1;
    },
    sterge_document: async function () {
      if (this.od_selected) {
        const od_ = this.ods[this.od_index];
        if (!confirm(`ATENTIE STERGETI Ordin de Deplasare inceput la ${od_.data_from_}?`)) {
          return
        }
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';
        try {
          const resp = await axi.delete(`rest_fc_faz_deleteOD/${od_.id}/`)
          const data = resp.data;
          if (data.ANS === 'OK') {
            this.schimba_data(0)
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          console.log(e)
        }
        panou.style.display = 'none'
        return;
      }
      
      const fc_=this.fcs[this.fc_index];

      if(confirm(`ATENTIE STERGETI document pentru ${fc_.utilaj__inventar} inceput la ${strftime("%H:%M %d/%m.%Y", new Date(fc_.data_in))} ?`)){
        const panou = document.getElementById("loading");
          panou.style.display = 'flex'; 
        try{
          const resp = await axi.delete(`rest_fc_faz_delete/${fc_.id}/`)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.schimba_data(0)
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
      }

    },
    incheie_timp: async function(){
      const fc_=this.fcs[this.fc_index];
      if(confirm(`Opriti timpul de lucru pentru ${fc_.utilaj__inventar} ?`)){
        const panou = document.getElementById("loading");
          panou.style.display = 'flex'; 
        try{
          const formData = {
            id: fc_.id, data_out: (new Date()).toISOString(),
            index_out: fc_.index_out, rezervor_in: fc_.rezervor_in, rezervor_out: fc_.rezervor_out,
            detalii_executie: fc_.detalii_executie, fct_motor: fc_.fct_motor
          }
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              
              Object.assign(this.fcs[this.fc_index], data.fc);
              let e = this.fcs[this.fc_index];
              e["ora_in"] = strftime("%H:%M", new Date(e.data_in))
                if(e.data_out !==null && e.data_out.length >9){
                  e["ora_out"] = strftime((new Date(e.data_in)).getDay() !== (new Date(e.data_out)).getDay() ? "%H:%M %d.%m.%Y": "%H:%M", new Date(e.data_out))
                }else e["ora_out"] = "--:--"

            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
      }
    },
    remorca_change: async function () {
      if(this.fcs[this.fc_index].remorca__id === null){
        // cauta in conexiuni si vezi ultima remorca
      }
      this.setare_remorca = true;
    },
    categorieSelectata: function(categorie){
      this.lcs_filtered = `${categorie}` === '-1' || `${categorie}`.startsWith('Toate') ? [...this.lcs]
        : this.lcs.filter(e => e.categorie == categorie);
    },
    async utilajSelectat(tip){
      //alert(tip)
      const panou = document.getElementById("loading");
            panou.style.display = 'flex';
      try {
        this.initFcEn = false
        this.initFazEn = false
        const resp = await axi.get(`rest_fc_faz_utilaje/?tip=${tip}`)
        const data = resp.data;
        if (data.ANS==='OK'){
            this.uts = [... data.Utilaje];
          }

      }catch(e){
        console.log(e)
      }
      panou.style.display = 'none'
    },
    async remorcaSelectat(tip){
      //alert(tip)
      const panou = document.getElementById("loading");
      if (tip == '') return;
      panou.style.display = 'flex';
      try {
        this.initFcEn = false
        this.initFazEn = false
        const resp = await axi.get(`rest_fc_faz_utilaje/?tip=${tip}`)
        const data = resp.data;
        if (data.ANS==='OK'){
            this.remorci = [... data.Utilaje];
          }

      }catch(e){
        console.log(e)
      }
      panou.style.display = 'none'
    },

    on_lucrare_selectata: function (dictionar) {
      this.edit_lucrare = false;
      this.lucrari[this.lucrare_index].lucrare = dictionar.id;
      this.de_salvat = true;
    },
    on_schimba_santier: function (santier) {
      this.de_salvat = this.rap.santier != santier;
      this.rap.santier = santier;
    },

    async utilaj_selectat(dictionar){
      const panou = document.getElementById("loading");
      panou.style.display = 'flex'; 
      this.utilaj_s = `${dictionar.inventar}-${dictionar.producator}, ${dictionar.model!=null?dictionar.model:''}`;
      this.utilaj_id = dictionar.id;
      this.utilaj_poateremorca = false;
        try{
          const resp = await axi.get(`rest_fc_faz_utilaj_index/${dictionar.id}/`)
          const data = await resp.data;
          if (data.ANS==='OK'){
            this.utilaj_i = data.INDEX
            this.utilaj_ii = data.INDEX
            this.utilaj_new_rezervor_in = data.rezervor_out;
            this.utilaj_poateremorca = data.poate_remorca;

            if (this.utilaj_poateremorca) {
              var tip_rem = data.remorca != null ? data.remorca.tip : this.remorci_type[0];
              if (data.remorca != null) {
                const ok_rem = await this.$refs.dialogDeConfirmare.show({
                  title: 'Remorca',
                  message: `Aveți atașată ${data.remorca.tip} ${data.remorca.inventar}?`,
                  okButton: 'Da',
                  cancelButton: 'Nu'
                });
                if (ok_rem) {
                  this.remorca = data.remorca;
                  this.remorca_s = `${data.remorca.inventar}-${data.remorca.producator ?? ''}, ${data.remorca.model ?? ''}`;
                } else {
                  alert('Nu uitați să selectați remorca / bena atașată.');
                  this.remorca = null;
                  this.remorca_s = '';
                } 
              } else {
                this.remorca_s = '';
                alert('Nu uitați să selectați remorca / bena atașată.');
              }
              console.log('Before DOM update:', this.$refs.selectTipRemorca);
              this.$nextTick(() => {
                console.log('After DOM update:', this.$refs.selectTipRemorca);
                if (this.$refs.selectTipRemorca) {
                  this.$refs.selectTipRemorca.selected = tip_rem;
                  this.$refs.selectTipRemorca.la_schimb();
                }
              });

            }
            // this.remorca = data.remorca;
            // if (this.remorca != null) {
            //   this.remorca_s = `${data.remorca.inventar}-${data.remorca.producator??''}, ${data.remorca.model??''}`;
            // } else {
            //   this.remorca_s = '';
            // }
            if (data.MSG?.length > 0)
              alert(data.MSG)
          }
          
          else{
            alert(data.MSG)
          }
          this.$nextTick(() => {
            this.initFcEn = data.fc_en;// ?? false
            this.initFazEn = data.faz_en;// ?? false
          });
          //this.initFcEn = data.fc_en;// ?? false
          //this.initFazEn = data.faz_en;// ?? false

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
    },

    async remorca_selectat(dictionar){
        const panou = document.getElementById("loading");
            panou.style.display = 'flex'; 
        this.remorca_s = `${dictionar.inventar}-${dictionar.producator}, ${dictionar.model!=null?dictionar.model:''}`;
        this.remorca = dictionar;
        try{
          const resp = await axi.get(`rest_fc_faz_status_remorca/${dictionar.id}/`)
          const data = await resp.data;
          if (data.ANS=='NOK' && data.MSG?.length > 0)
            alert(data.MSG)
          this.initFazEn = data.faz_en ?? false

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
    },

    async init_doc(faz=false){
      //alert(this.sass)
      if(this.sass=='SNimic'){
        alert("Alegeti santierul")
        return;
        }

      if (this.utilaj_id > -1){
        if((this.utilaj_ii > -5) && (this.utilaj_ii != this.utilaj_i)) 
        { //alert(`original=${this.utilaj_ii} modificat=${this.utilaj_i}`)
          if(!confirm(`Indexul vechi este ${this.utilaj_ii} iar cel introdus de dumneavoastra este ${this.utilaj_i} doriti sa continuati?`)){
            return;
          } 
        }
        if (this.utilaj_i < 0) {
          alert('Va rog sa introduceti indexul, acesta nu poate fi negativ.');
          return;
        }

        if (faz && this.remorca == null && this.utilaj_poateremorca) {
          const ok_rem_init = await this.$refs.dialogDeConfirmare.show({
                  title: 'Atenție',
                  message: `Nu aveți remorcă / benă selectată! Inițiați faz-ul fără remorcă? `,
                  okButton: 'Da',
                  cancelButton: 'Nu'
          });
          if (!ok_rem_init) {
            return;
          }
        }

        this.fc_new = false
        const panou = document.getElementById("loading");
          panou.style.display = 'flex'; 
      
        try{
          const formData = {data_in: this.data.toISOString().substring(0, 10) + (new Date()).toISOString().substring(10,24),
              utilaj: this.utilaj_id,
              index_in: this.utilaj_i,
              faz: faz,
              remorcax: this.remorca?.id,
              rezervor_in: this.utilaj_new_rezervor_in, 
              punct_lucru: this.sass}
              
          const resp = await axi.post(`rest_fc_faz_add/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              this.schimba_data(0);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
        
      }

    },

    select_data_od() {
      if (this.sass == 'SNimic') {
        alert("Alegeti santierul")
        return;
      }
      if ((this.utilaj_id < 0) && (!confirm('NU ATI SELECTAT UTILAJUL!\nSunteti sigur ca doriti sa deschideti un Ordin de deplasare?'))) {
        return;

      }
      this.fc_new = false;
      this.od_data_from = this.data.toISOString().substring(0,10);
      this.od_data_to = this.data.toISOString().substring(0,10);
      this.od_new_data = true;
    },

    async init_od() {   
        //verificare date
      const df = Date.parse(this.od_data_from);
      if (isNaN(df)) {
        alert("Verificati data de pornire");
        return;
      }
      if ((new Date() - df) / (86400000) > 37) {
        alert("Data de pornire prea veche");
        return;
      }
       if (new Date() < df) {
        alert("Data de pornire este in viitor");
        return;
      }

      const dt = Date.parse(this.od_data_to);
      if (isNaN(dt)) {
        alert("Verificati data de plecare");
        return;
      }

      if ((dt - df) / (86400000) > 31) {
        alert("Interval prea mare");
        return;
      }
      if (dt < df) {
        alert("Data de sfarsit mai mica ca cea de pornire");
        return;
      }
    
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';

        try {
          const formData = {
            data_from: (new Date(df)).toISOString().substring(0, 10),// + (new Date()).toISOString().substring(10, 24),
            data_to: (new Date(dt)).toISOString().substring(0, 10),
            punct_lucru: this.sass
          }
          if (this.utilaj_id > 0) {
            formData['utilaj'] = this.utilaj_id;
          } else {
            //formData['comanda'] = '000000000'
          }

          const resp = await axi.post(`rest_fc_faz_addOD/`, formData)
          const data = resp.data;
          if (data.ANS === 'OK') {
            this.schimba_data(0);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          console.log(e)
        }
        panou.style.display = 'none'

      
    },

    async init_faz() {
      await this.init_doc(true);
    },
    async init_fc() {
      await this.init_doc(false);
    },

    intreaba_alt_index: async function(){
      if(confirm("Schimbati indexul initial?")){
        const new_index = parseInt(prompt("Introduceti indexul initial:", this.fcs[this.fc_index].index_in))
        if((isNaN(new_index)) || (new_index < 1)){
          alert("Indexul introdus nu exte un numar valid!")
          return;
        }
        const panou = document.getElementById("loading");
          panou.style.display = 'flex';
        let fc_ = this.fcs[this.fc_index] 
        try{
          const formData = {index_in: new_index}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              Object.assign(this.fcs[this.fc_index], data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'

      }
    },

    trimite_la_confirmat: async function(){
      //verificare index final
      if (this.fcs[this.fc_index].index_out == null ||
        isNaN(this.fcs[this.fc_index].index_out) ||
        (this.fcs[this.fc_index].index_out < this.fcs[this.fc_index].index_in) ||
        ((this.fcs[this.fc_index].index_out - this.fcs[this.fc_index].index_in > this.ore_max()) && !this.fcs[this.fc_index].faz )) {
        alert("Verificati indexul final");
        return;
      }
    
      if(this.fcs[this.fc_index].rezervor_in==null || isNaN(this.fcs[this.fc_index].rezervor_in)||(this.fcs[this.fc_index].rezervor_in < 0) || (this.fcs[this.fc_index].rezervor_in >2999)){
        alert("Verificati Rezervor initial");return;
      }
      if(this.fcs[this.fc_index].rezervor_out==null || isNaN(this.fcs[this.fc_index].rezervor_out)||(this.fcs[this.fc_index].rezervor_out < 0) || (this.fcs[this.fc_index].rezervor_out >2999)){
        alert("Verificati Rezervor final");return;
      }
      let alimentare_total = 0
      this.fcs[this.fc_index].alimentari.forEach( alim => alimentare_total += alim.alimentare);
      let diferenta_rezervor = this.fcs[this.fc_index].rezervor_in + alimentare_total - this.fcs[this.fc_index].rezervor_out;
      if (diferenta_rezervor < 0){
        alert(`Verificati Rezervor initial, final, si alimentari\n (surplus ${diferenta_rezervor * -1} litri)!!!\n Ati uitat sa treceti o alimentare?`);
        return;
      }
      let fcu = this.fcs[this.fc_index]
      if (fcu.index_in < fcu.index_out && fcu.rezervor_in == fcu.rezervor_out && fcu.alimentari.length == 0) {
        alert(`Verificati index, rezervor si alimentari!!!\nAveti ${fcu.index_out - fcu.index_in} ore lucrate cu acelasi stoc si fara alimentari!\nAti uitat sa treceti o alimentare?`);
        return;
      }
      if (fcu.fct_motor < 0 || fcu.fct_motor > 24) {
        alert('Verificati orele functionare motor!');
        return;
      }
      if (fcu.faz && fcu.transp.length == 0) {
        alert('Nu aveti date de transport?\nAceasta este o foaie de parcurs!!!')
        return;
      }
      // if (fcu.lucrare == null && confirm("Ați efectuat revizie / lucrări de mentenanță ?")) {
      //   return;
      // }
      if (fcu.lucrare == null) {
        const ok = await this.$refs.dialogDeConfirmare.show({
          title: 'confirmare',
          message: 'Ați efectuat revizie / lucrări de mentenanță ?',
          okButton: 'NU',
          cancelButton: 'Da'
        })
        if (!ok) {
          this.editeaza_lucrare();
          return;
        }
      }
      
      this.selecteaza_inginer = true;
    },

    trimite_la_confirmatOD: function () {
      //verificare index final
      this.selecteaza_inginer = true;
    },

    uita_inginer_selectat: function(){
      this.selecteaza_inginer = false
    },

    inginer_confirmare: async function(ing){
      const panou = document.getElementById("loading");
      panou.style.display = 'flex';
      if (this.od_selected) {
        try {
          let od_ = this.ods[this.od_index]
          const formData = {
            id: od_.id,
            data_to: od_.data_to.length === 10 ? od_.data_to : od_.data_from__,
            inginer: ing.id,
            lucrare: od_.lucrare,
            satre: 1,
          }
          const resp = await axi.put(`rest_fc_faz_updateOD/${od_.id}/`, formData)
          const data = resp.data;
          if (data.ANS === 'OK') {
            Object.assign(this.ods[this.od_index], data.od);
          } else {
            alert(data.MSG);
          }

        } catch (e) {
          console.log(e);
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'
        return;
      }    
        let fc_ = this.fcs[this.fc_index] 
        try{
          const formData = {id: fc_.id,
            data_out: (fc_.data_out == null || fc_.data_out.length < 10) ? (new Date()).toISOString(): fc_.data_out,
            inginer: ing.id, index_out: fc_.index_out, rezervor_in: fc_.rezervor_in, rezervor_out: fc_.rezervor_out,
            fct_motor: fc_.fct_motor,
            detalii_executie: fc_.detalii_executie, satre: 1}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              Object.assign(this.fcs[this.fc_index], data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'
    },

    retrage_la_confirmat: async function () {
      const panou = document.getElementById("loading");
      if (this.od_selected) {
        let od_ = this.ods[this.od_index]
        if (od_.satre == 2) return
        panou.style.display = 'flex';
        try {
          const formData = {
            id: od_.id,
            satre: 0
          }
          const resp = await axi.put(`rest_fc_faz_updateOD/${od_.id}/`, formData)
          const data = resp.data;
          if (data.ANS === 'OK') {
            Object.assign(this.ods[this.od_index], data.od);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          console.log(e)
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'
        return;
      }
        
        let fc_ = this.fcs[this.fc_index] 
        if(fc_.satre==2)return
        
        panou.style.display = 'flex';
        
        try{
          const formData = {id: fc_.id,
            satre: 0}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              Object.assign(this.fcs[this.fc_index], data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        this.selecteaza_inginer = false
        panou.style.display = 'none'
    },

    ichange: async function(e){
      //alert(e.target.files[0]);
      const config = {file: e.target.files[0], maxSize: 800}
      const resizedImage = await resizeImage(config)
      this.alimentare_imagine_noua = resizedImage;
      this.alimentare_este_document = 'pregatit';
    },
    pre_save: async function(){
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';
        var rez = true
        let fc_ = this.fcs[this.fc_index] 
        try{
          const formData = {id: fc_.id,
            index_out: fc_.index_out, rezervor_in: fc_.rezervor_in, rezervor_out: fc_.rezervor_out,
            detalii_executie: fc_.detalii_executie, fct_motor: fc_.fct_motor}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              Object.assign(this.fcs[this.fc_index], data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
          rez = false
        }
      panou.style.display = 'none'
      return rez
    },

    remorca_save: async function(){
      const panou = document.getElementById("loading");
      panou.style.display = 'flex';
      let fc_ = this.fcs[this.fc_index]
      try{
        const formData = {id: fc_.id, remorcax: this.remorca.id}
        const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
        const data = resp.data;
        if (data.ANS==='OK'){
            Object.assign(this.fcs[this.fc_index], data.fc);
          }
        else{
          alert(data.MSG)
        }

      }catch(e){
        console.log(e)
      }
      panou.style.display = 'none'
      this.setare_remorca = false;
    },

    remorca_delete: async function(){
      if(confirm(`Stergeți remorca de la ${this.fcs[this.fc_index].utilaj__inventar}?`)){
        const panou = document.getElementById("loading");
        panou.style.display = 'flex';
        let fc_ = this.fcs[this.fc_index]
        try{
          const formData = {id: fc_.id, remorcax: null}
          const resp = await axi.put(`rest_fc_faz_put/${fc_.id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              Object.assign(this.fcs[this.fc_index], data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        panou.style.display = 'none'
        this.setare_remorca = false;
      }
    },

    check_alimentare: async function () {
      let fc_ = this.fcs[this.fc_index]
      //const panou = document.getElementById("loading");
      //panou.style.display = 'flex';
      let inc = document.getElementById('incarcare')
          inc.classList.add('is-active')
      var raspuns = false
      try {
        const resp = await axi.get(`rest_fc_faz_ask_alimentare/${fc_.id}/`)
        const data = resp.data
        if ((data.ANS === 'OK') && (data.alimcis_list.length > 0)) {
          let na = data.alimcis_list[0]
          if (confirm(`Ati alimentat ${na.alimentare.toFixed(0)} litri de la ${na.cisterna} cu bon nr: ${na.bon}. Acesta alimentare doriti sa o adaugati la fc?`)) {
            const rresp = await axi.post('rest_fc_faz_confirm_alimentare/', {fc: fc_.id, alimcis: na.id})
            const rdata = rresp.data
            if (rdata.ANS === 'OK') {
              Object.assign(this.fcs[this.fc_index], rdata.fc)
              this.$forceUpdate()
            } else {
              alert(rdata.MSG)
            }  
            raspuns = true
          }
        }
      } catch (e) {
        console.log(e)
      }
      //panou.style.display = 'none'
      inc.classList.remove('is-active')  
      return raspuns
    },

    alimentare_save: async function(){
      let inc = document.getElementById('incarcare')
          inc.classList.add('is-active')
    
        try{
          const formData = new FormData();
          formData.append('fc', this.alimentare_fc);
          formData.append('alimentare', this.alimentare_litri);
          formData.append('furnizor', this.alimentare_de_la);
          if (this.alimentare_imagine_noua)
            formData.append('imagine', this.alimentare_imagine_noua, "bon_nou.jpeg" );
          let resp;
          if (this.alim_id==null)
            resp = await axi.post(`rest_fc_faz_add_alimentare/`, formData)
          else
            resp = await axi.put(`rest_fc_faz_put_alimentare/${this.alim_id}/`, formData)
          const data = resp.data;
          if (data.ANS==='OK'){
              Object.assign(this.fcs[this.fc_index], data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          console.log(e)
        }
        this.selecteaza_inginer = false
        //panou.style.display = 'none'
        inc.classList.remove('is-active')  

      this.alim_edit = false;
    },

    alimentare_sterge: async function(){
      if(confirm(`Sigur stergeti alimentarea de ${this.alimentare_litri} de la ${this.alimentare_de_la}?`)){
        //const panou = document.getElementById("loading");
        //panou.style.display = 'flex';
        let inc = document.getElementById('incarcare')
        inc.classList.add('is-active')
        
        try{
          const  resp = await axi.delete(`rest_fc_faz_delete_alimentare/${this.alim_id}/`)
          const data = resp.data;
          if (data.ANS==='OK'){
              Object.assign(this.fcs[this.fc_index], data.fc);
            }
          else{
            alert(data.MSG)
          }

        }catch(e){
          alert(e)
          console.log(e)
        }
        this.selecteaza_inginer = false
        //panou.style.display = 'none'
        inc.classList.remove('is-active')  
      }

      this.alim_edit = false;
    },
    alimentare_show: function(alimentare){
      this.alimentare_litri = alimentare.alimentare;
      this.alimentare_de_la = alimentare.furnizor;
      this.alimentare_este_document = 'OK';
      this.alimentare_fc = this.fcs[this.fc_index].id;
      this.alim_id =alimentare.id;
      this.alimentare_imagine_noua = null;
      this.alimentare_imagine = alimentare.imagine;
      //TODO:
      //Sa nu uiti de imagine  alimentare.imagine
      this.alim_edit = !this.alim_edit;
    },
    alimentare_add: async function () {
      await this.pre_save()
      let iesi = await this.check_alimentare()
      if (iesi) {
        return
      }
      this.alimentare_litri = '';
      this.alimentare_de_la = '';
      this.alimentare_este_document = 'nu';
      this.alimentare_fc = this.fcs[this.fc_index].id;
      this.alim_id = null;
      this.alimentare_imagine_noua = null;
      this.alimentare_imagine = null;
      //TODO:
      //Sa nu uiti de imagine
      this.alim_edit = true;
    },

    alimentare_close: function(){
      this.alim_edit = false;
    },

    arata_cursa: function (cursa) {
      if (cursa == -1) {
        this.traseu_id = null;
        this.traseu_plecare = '';
        this.traseu_sosire = '';
        this.traseu_km_gol = 0;
        this.traseu_ckm_gol = 0;
        this.traseu_km_plin = 0;
        this.traseu_ckm_plin = 0;
        this.traseu_detalii_transport = '';
        this.traseu_cantitate = 0;
        this.traseu_tip_incarcatura = '';
        this.traseu_nr_curse = 1;
        this.traseu_basculari = 0;
        this.traseu_cbasculari = 0;
      } else {
        const tr = this.fcs[this.fc_index].transp[cursa];
        this.traseu_id = tr.id;
        this.traseu_plecare = tr.plecare;
        this.traseu_sosire = tr.sosire;
        this.traseu_km_gol = tr.km_gol;
        this.traseu_ckm_gol = tr.ckm_gol;
        this.traseu_km_plin = tr.km_plin;
        this.traseu_ckm_plin = tr.ckm_plin;
        this.traseu_detalii_transport = tr.detalii_transport;
        this.traseu_cantitate = tr.cantitate;
        this.traseu_tip_incarcatura = tr.tip_incarcatura;
        this.traseu_nr_curse = tr.nr_curse;
        this.traseu_basculari = tr.basculari;
        this.traseu_cbasculari = tr.cbasculari;
      }
      this.traseu_edit = true;
    },

    traseu_close: function () {
      this.traseu_edit = false;
    },

    traseu_sterge: async function () {
      if (!this.traseu_id) return;
      if (confirm(`Sigur stergeti traseul?`)) {
        let inc = document.getElementById('incarcare')
        inc.classList.add('is-active')

        try {
          const resp = await axi.delete(`rest_fc_faz_delete_transport/${this.traseu_id}/`)
          const data = resp.data;
          if (data.ANS === 'OK') {
            Object.assign(this.fcs[this.fc_index], data.fc);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          alert(e)
          console.log(e)
        }
        
        inc.classList.remove('is-active')
      }

      this.traseu_edit = false;
    },

    traseu_save: async function () {
      let inc = document.getElementById('incarcare')
      inc.classList.add('is-active')

      try {
        const formData = {
          plecare: this.traseu_plecare, sosire: this.traseu_sosire,
          km_gol: this.traseu_km_gol, ckm_gol: this.traseu_ckm_gol,
          km_plin: this.traseu_km_plin, ckm_plin: this.traseu_ckm_plin,
          detalii_transport: this.traseu_detalii_transport,
          cantitate: this.traseu_cantitate, tip_incarcatura: this.traseu_tip_incarcatura,
          nr_curse: this.traseu_nr_curse, fc: this.fcs[this.fc_index].id,
          basculari: this.traseu_basculari
        }
        let resp;
        if (this.traseu_id == null)
          resp = await axi.post(`rest_fc_faz_add_transport/`, formData)
        else
          resp = await axi.put(`rest_fc_faz_put_transport/${this.traseu_id}/`, formData)
        const data = resp.data;
        if (data.ANS === 'OK') {
          Object.assign(this.fcs[this.fc_index], data.fc);
        }
        else {
          alert(data.MSG)
        }

      } catch (e) {
        console.log(e)
      }
      inc.classList.remove('is-active')

      this.traseu_edit = false;
    },
    traseu_tip_incarcatura_selectat: function (tip) {
      this.traseu_tip_incarcatura = tip[0];
    },
    ore_max: function () {
      return ['Compresor', 'Generator', 'Nacela', 'Placa compactoare', 'Pompa'].includes(this.fcs[this.fc_index].utilaj__tip) ? 720 : 24; 
    },

    lucrare_save: async function () {
      let inc = document.getElementById('incarcare')
      inc.classList.add('is-active')

      try {
        const formData = {
          fc: this.fcs[this.fc_index].id,
          ulei_motor: this.ulei_motor, filtru_ulei_motor: this.filtru_ulei_motor,
          filtru_combustibil: this.filtru_combustibil, filtru_aer: this.filtru_aer,
          filtru_polen: this.filtru_polen, filtru_adblue: this.filtru_adblue, filtru_uscator: this.filtru_uscator,
          ulei_cutie: this.ulei_cutie, filtru_ulei_cutie: this.filtru_ulei_cutie,
          ulei_punte: this.ulei_punte,
          ulei_hidraulic: this.ulei_hidraulic, filtru_ulei_hidraulic: this.filtru_ulei_hidraulic,
          lucrare_detalii : this.lucrare_detalii,
        }
        let resp;
        if (this.fcs[this.fc_index].lucrare == null)
          resp = await axi.post(`rest_fc_faz_add_lucrarefc/`, formData)
        else
          resp = await axi.put(`rest_fc_faz_put_lucrarefc/${this.fcs[this.fc_index].lucrare.id}/`, formData)
        const data = resp.data;
        if (data.ANS === 'OK') {
          Object.assign(this.fcs[this.fc_index], data.fc);
        }
        else {
          alert(data.MSG)
        }

      } catch (e) {
        console.log(e)
      }
      inc.classList.remove('is-active')

      this.lucrare_edit = false;
      
    },

    editeaza_lucrare: function () {
      const lu = this.fcs[this.fc_index].lucrare
      if (lu != null){ 
        this.ulei_motor = lu.ulei_motor;
        this.filtru_ulei_motor = lu.filtru_ulei_motor;
        this.filtru_combustibil = lu.filtru_combustibil;
        this.filtru_aer = lu.filtru_aer;
        this.filtru_polen = lu.filtru_polen;
        this.filtru_adblue = lu.filtru_adblue;
        this.filtru_uscator = lu.filtru_uscator;
        this.ulei_cutie = lu.ulei_cutie;
        this.filtru_ulei_cutie = lu.filtru_ulei_cutie;
        this.ulei_punte = lu.ulei_punte;
        this.ulei_hidraulic = lu.ulei_hidraulic;
        this.filtru_ulei_hidraulic = lu.filtru_ulei_hidraulic;
        this.lucrare_detalii = lu.lucrare_detalii;
      }else{
        this.ulei_motor = false;
        this.filtru_ulei_motor = false;
        this.filtru_combustibil = false;
        this.filtru_aer = false;
        this.filtru_polen = false;
        this.filtru_adblue = false;
        this.filtru_uscator = false;
        this.ulei_cutie = false;
        this.filtru_ulei_cutie = false;
        this.ulei_punte = false;
        this.ulei_hidraulic = false;
        this.filtru_ulei_hidraulic = false;
        this.lucrare_detalii = "";
      }
      this.lucrare_edit = true;
    },

    lucrare_close: function () {
      this.lucrare_edit = false;
    },

    lucrare_sterge: async function () {
      // TODO: modifica aici functia
      if (!this.fcs[this.fc_index].lucrare) return;
      if (confirm(`Sigur stergeti schimburile / lucrarile ?`)) {
        let inc = document.getElementById('incarcare')
        inc.classList.add('is-active')

        try {
          
          const resp = await axi.delete(`rest_fc_faz_delete_lucrarefc/${this.fcs[this.fc_index].lucrare.id}/`)
          const data = resp.data;
          if (data.ANS === 'OK') {
            Object.assign(this.fcs[this.fc_index], data.fc);
          }
          else {
            alert(data.MSG)
          }

        } catch (e) {
          alert(e)
          console.log(e)
        }

        inc.classList.remove('is-active')
      }

      this.lucrare_edit = false;
    },

  }
  
}
</script>

<style scoped>

.flex-box-2 {
  display:flex;
  justify-content: space-between;
  align-content: center;
  outline: 2px rgb(66, 63, 65) none;
  background-color: aliceblue;
  margin-bottom:0.3em;
}

.plus-squared {
  background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iY3VycmVudENvbG9yIiBjbGFzcz0iYmkgYmktcGx1cy1zcXVhcmUiIHZpZXdCb3g9IjAgMCAxNiAxNiI+CiAgPHBhdGggZD0iTTE0IDFhMSAxIDAgMCAxIDEgMXYxMmExIDEgMCAwIDEtMSAxSDJhMSAxIDAgMCAxLTEtMVYyYTEgMSAwIDAgMSAxLTFoMTJ6TTIgMGEyIDIgMCAwIDAtMiAydjEyYTIgMiAwIDAgMCAyIDJoMTJhMiAyIDAgMCAwIDItMlYyYTIgMiAwIDAgMC0yLTJIMnoiLz4KICA8cGF0aCBkPSJNOCA0YS41LjUgMCAwIDEgLjUuNXYzaDNhLjUuNSAwIDAgMSAwIDFoLTN2M2EuNS41IDAgMCAxLTEgMHYtM2gtM2EuNS41IDAgMCAxIDAtMWgzdi0zQS41LjUgMCAwIDEgOCA0eiIvPgo8L3N2Zz4=");
}

/* The Modal (background) */
  .modall {
    display: block;
    /* Hidden by default */
    position: absolute;
    /* Stay in place */
    z-index: 10;
    /* Sit on top */
    padding-top: 100px;
    /* Location of the box */
    left: 0;
    top: 0;
    width: 100%;
    /* Full width */
    height: 100%;
    /* Full height */
    overflow: auto;
    /* Enable scroll if needed */
    background-color: rgb(0, 0, 0);
    /* Fallback color */
    background-color: rgba(0, 0, 0, 0.9);
    /* Black w/ opacity */
  }

  /* Modal Content (image) */
  .modall-content {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
  }

    /* Caption of Modal Image */
  #caption {
    margin: auto;
    display: block;
    width: 80%;
    max-width: 700px;
    text-align: center;
    color: #ccc;
    padding: 10px 0;
    height: 60px;
  }

  /* Add Animation */
  .modall-content,
  #caption {
    -webkit-animation-name: zoom;
    -webkit-animation-duration: 0.6s;
    animation-name: zoom;
    animation-duration: 0.6s;
  }

  @-webkit-keyframes zoom {
    from {
      -webkit-transform: scale(0)
    }

    to {
      -webkit-transform: scale(1)
    }
  }

  @keyframes zoom {
    from {
      transform: scale(0)
    }

    to {
      transform: scale(1)
    }
  }

  /* The Close Button */
  .close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #f1f1f1;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
  }

  .close:hover,
  .close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
  }

   /* 100% Image Width on Smaller Screens */
  @media only screen and (max-width: 700px) {
    .modal-content {
      width: 100%;
    }

    /*signature pad css  */
    .wrapper {
      position: relative;
      width: 400px;
      height: 200px;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    img .sig {
      position: absolute;
      left: 0;
      top: 0;
    }

    .signature-pad {
      position: absolute;
      left: 0;
      top: 0;
      width: 400px;
      height: 200px;
      background-color: gray;
    }

    .svg-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-image: url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-wrench" viewBox="0 0 16 16"><path d="M.102 2.223A3.004 3.004 0 0 0 3.78 5.897l6.341 6.252A3.003 3.003 0 0 0 13 16a3 3 0 1 0-.851-5.878L5.897 3.781A3.004 3.004 0 0 0 2.223.1l2.141 2.142L4 4l-1.757.364L.102 2.223zm13.37 9.019.528.026.287.445.445.287.026.529L15 13l-.242.471-.026.529-.445.287-.287.445-.529.026L13 15l-.471-.242-.529-.026-.287-.445-.445-.287-.026-.529L11 13l.242-.471.026-.529.445-.287.287-.445.529-.026L13 11l.471.242z"/></svg>');
      background-size: cover;
    }

  }

</style>
